// const dependencyRx = /^(?!.*\.(spec|test)\.(js|ts)$).*\.(js|ts)$/; // todo: move to reusable place
const dependencies = importAngularDependencies(
  require.context(
    './',
    true,
    /^(?!.*\.(spec|test|d)\.(js|ts|tsx)$).*\.(js|ts|tsx)$/
  ),
  './common.js'
);

export default angular.module('doxy.common', dependencies).name;
